import React from 'react';
import {
  Card as PrimeCard,
  CardProps as PrimeCardProps,
} from 'primereact/card';

interface GFNCardProps extends Omit<PrimeCardProps, 'style'> {
  /**
   * Custom test ID for testing
   */
  testId?: string;

  /**
   * Custom inline styles
   */
  style?: React.CSSProperties;

  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * GFN Card Component
 */
const GFNCard = React.forwardRef<any, GFNCardProps>(
  ({ testId, className = '', ...restProps }, ref) => {
    return (
      <PrimeCard
        ref={ref}
        className={`p-md ${className}`}
        data-testid={testId}
        {...restProps}
      />
    );
  }
);

GFNCard.displayName = 'GFNCard';

export default GFNCard;
export { GFNCard };